class Menu {
    constructor() {
        this.initializeMenu();
    }

    initializeMenu() {
        const menuItems = document.querySelectorAll('.menu__item[aria-haspopup="true"]');

        menuItems.forEach(item => {
            const link = item.querySelector('.menu__link');
            const submenu = item.querySelector('.menu__submenu-container');

            item.addEventListener('keydown', (e) => {
                if (e.key === ' ') {
                    e.preventDefault();
                    const isExpanded = item.getAttribute('aria-expanded') === 'true';
                    if (isExpanded) {
                        this.toggleMenu(item, false);
                        link.focus();
                    } else {
                        this.closeAllMenus();
                        this.toggleMenu(item, true);
                    }
                } else if (e.key === 'Enter') {
                    if (link) {
                        window.location.href = link.getAttribute('href');
                    }
                }
            });

            if (link) {
                link.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const isExpanded = item.getAttribute('aria-expanded') === 'true';
                    this.closeAllMenus();
                    this.toggleMenu(item, !isExpanded);
                });
            }

            // Zamknięcie podmenu po utracie focusu
            item.addEventListener('focusout', (e) => {
                const relatedTarget = e.relatedTarget;
                if (!item.contains(relatedTarget) || (relatedTarget && !relatedTarget.closest('.menu__item[aria-haspopup="true"]'))) {
                    this.toggleMenu(item, false);
                }
            });

            // Obsługa myszki - otwieranie podmenu na hover
            item.addEventListener('mouseover', () => {
                this.toggleMenu(item, true);
            });

            item.addEventListener('mouseout', () => {
                this.toggleMenu(item, false);
            });
        });

        // Zamknięcie wszystkich podmenu podczas przejścia focusu na inny element
        document.addEventListener('focusin', (e) => {
            const activeElement = e.target.closest('.menu__item[aria-haspopup="true"]');
            if (!activeElement) {
                this.closeAllMenus();
            }
        });

        // Zamknięcie wszystkich podmenu podczas kliknięcia poza menu
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.menu__item')) {
                this.closeAllMenus();
            }
        });
    }

    toggleMenu(menuItem, show) {
        const submenu = menuItem.querySelector('.menu__submenu-container');
        if (submenu) {
            submenu.setAttribute('aria-hidden', !show);  // Dodaj aria-hidden dla dostępności
            if (show) {
                submenu.style.display = 'block';
                submenu.style.maxHeight = '100%';
                submenu.style.opacity = '1';
                submenu.style.visibility = 'visible';
                menuItem.setAttribute('aria-expanded', 'true');
            } else {
                submenu.style.display = 'none';
                submenu.style.maxHeight = '0';
                submenu.style.opacity = '0';
                submenu.style.visibility = 'hidden';
                menuItem.setAttribute('aria-expanded', 'false');
            }
        }
    }

    closeAllMenus() {
        const menuItems = document.querySelectorAll('.menu__item[aria-haspopup="true"]');
        menuItems.forEach(item => {
            this.toggleMenu(item, false);
        });
    }
}

export default function initializeWCAG() {
    const menu = new Menu();

    // Opcjonalnie, inicjalizacja biblioteki What Input
    import('what-input').then(() => {
        console.log('What Input? initialized');
    });
}
